import { Component, Input } from "@angular/core";
import { SchemaErrorDetail } from 'z-schema';
import { Widget, FormProperty } from "./angular2-schema-form-shim";
import { getWidgetType, isWidgetRequired } from "./widgets/overrides";

@Component( {
  selector: 'sp-widget-error',
  templateUrl: './error.component.html',
} )
export class WidgetValidationError {

  @Input() public widget: Widget<FormProperty>;

  @Input() public errors: SchemaErrorDetail[] = [];

  constructor() {
  }

  get hasErrors() {
    return this.errors && this.errors.length > 0;
  }

  get required() {
    return isWidgetRequired( this.widget );
  }

  errorIdentity( index: number, message: string ): string {
    return message;
  }

  get uniqueMessages(): string[] {
    const seen = new Set<string>();
    const result: string[] = [];
    for ( const error of this.errors ) {
      const message = this.niceMessage( error );
      if ( !seen.has( message ) ) {
        seen.add( message );
        result.push( message );
      }
    }
    return result;
  }

  niceMessage( error: SchemaErrorDetail ): string {
    const isSelect = this.widget && getWidgetType( this.widget ) === 'select';

    switch ( error.code ) {

      case 'PROPERTY_VALUE_REQUIRED':
        return isSelect ? 'Please select an option' : 'This field is required';

      case 'INVALID_TYPE':
      case 'ENUM_MISMATCH':
        if ( isSelect ) return 'Please select an option';
        return error.message;

      default: return error.message;

    }
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/error.component.ts